import apiClient from '@/lib/api-client'

function AuthService() {
  async function csrf() {
    return await apiClient('/sanctum/csrf-cookie')
  }

  function organizationRequests() {
    async function index(query) {
      await csrf()

      return await apiClient('/active-organizations' + query)
    }

    async function store(data) {
      await csrf()

      return await apiClient('/organization-registrations', {
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    }

    return {
      index,
      store,
    }
  }

  function accountRequests() {
    async function show({ key }) {
      await csrf()

      return await apiClient('/account-requests/' + key)
    }

    async function store(data) {
      await csrf()

      return await apiClient('/account-requests', {
        method: 'POST',
        body: data,
      })
    }

    return {
      show,
      store,
    }
  }

  async function register(data) {
    await csrf()

    return await apiClient('/register', {
      method: 'POST',
      body: data,
    })
  }

  async function login(data) {
    await csrf()

    return await apiClient('/login', {
      method: 'POST',
      body: data,
    })
  }

  async function forgotPassword(data) {
    await csrf()

    return await apiClient('/forgot-password', {
      method: 'POST',
      body: data,
    })
  }

  async function resetPassword({ token, data }) {
    await csrf()

    return await apiClient('/reset-password?token=' + token, {
      method: 'POST',
      body: data,
    })
  }

  async function logout() {
    await csrf()

    return await apiClient('/logout', {
      method: 'POST',
    })
  }

  return {
    organizationRequests,
    accountRequests,
    register,
    login,
    forgotPassword,
    resetPassword,
    logout,
  }
}

export default AuthService
